import { render, staticRenderFns } from "./AuthorUserMenu.vue?vue&type=template&id=9a639ecc"
import script from "./AuthorUserMenu.vue?vue&type=script&lang=js"
export * from "./AuthorUserMenu.vue?vue&type=script&lang=js"
import style0 from "./AuthorUserMenu.vue?vue&type=style&index=0&id=9a639ecc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports